import { Injectable } from "@angular/core";
import LogRocket from "logrocket";
import brandInfo from "../../environments/brand.json";
import { last, Observable, take, throwError } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GatewayService } from "./gateway.service";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})


// Capture Console Errors
// Capture API Errors
export class LoggingService {
  constructor(private httpClient: HttpClient, private gatewayService: GatewayService) {}

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  init() {
    // Initialize LogRocket with your app ID
    if(environment.production){
      LogRocket.init(`${environment.logrocket}`, {
        dom: {
          inputSanitizer: true,
        },
        network: {
          isEnabled: false,
        },
        console: {
          isEnabled: false,
        },
      });
    }

  }

  storeLogRocket(lead, payload) {
    const correlationId = sessionStorage.getItem("correlationId");
    const logRocketUser = {
      name: `${lead.customer.firstName} ${lead.customer.lastName}`,
      phoneNumber1: `${lead.customer.phoneNumber1}`,
      phoneNumber2: `${lead.customer.phoneNumber2}`,
      AgentId: payload.AgentId ? payload.AgentId : "",
      prid: payload.prid ? payload.prid : "",
      correlationId: correlationId
    };

    console.log("Storing User to LogRocket: ", lead.customer.contactSfId, logRocketUser, correlationId);
    if(environment.production){
      LogRocket.identify(payload.oid || correlationId, logRocketUser);
    }
  }

  static captureLogRocketError(httpResponse, type = "Error", message = "Error", service?: string) {
    let _vehicle = sessionStorage.getItem("vehicle");

    let _urlParams = JSON.parse(sessionStorage.getItem("urlParams"));

    // Sanitize response to exclude rates data for get_rates service
    let sanitizedHttpResponse = httpResponse;
    let sanitizedError = httpResponse.error;
    
    if (service === "get_rates") {
      sanitizedError = {
        message: httpResponse.error?.message || httpResponse.error?.errorMessage || "Error getting rates",
        status: httpResponse.error?.status || httpResponse.status,
        errorMessage: httpResponse.error?.errorMessage || httpResponse.error?.message || "Error getting rates"
      };
      sanitizedHttpResponse = {
        status: httpResponse.status,
        statusText: httpResponse.statusText,
        url: httpResponse.url,
        error: sanitizedError
      };
    }

      console.log({
        brand: brandInfo.brand,
        oid: _urlParams && _urlParams.oid || "",
        prid: _urlParams && _urlParams.prid || "",
        error: JSON.stringify(sanitizedError),
        httpResponse: JSON.stringify(sanitizedHttpResponse),
      });
      if(environment.production){
        LogRocket.captureMessage(message, {
          tags: {
            errorType: type,
          },
          extra: {
            brand: brandInfo.brand,
            oid: _urlParams && _urlParams.oid || "",
            prid: _urlParams && _urlParams.prid || "",
            error: JSON.stringify(sanitizedError),
            httpResponse: JSON.stringify(sanitizedHttpResponse),
          },
        });
    }
  }

  captureD2CError(httpResponse, type = "Error", message = "Error", severity, service) {
    let _lead = JSON.parse(sessionStorage.getItem("lead"));
    let _urlParams = JSON.parse(sessionStorage.getItem("urlParams"));

    let url = "";
    if(service ==="payment"){
      url = httpResponse.url;
    }else {
      url = httpResponse.error.path
    }

    // Sanitize response to exclude rates data for get_rates service
    let sanitizedResponse = httpResponse;
    if (service === "get_rates") {
      sanitizedResponse = {
        status: httpResponse.status,
        statusText: httpResponse.statusText,
        url: httpResponse.url,
        error: {
          message: httpResponse.error?.message || httpResponse.error?.errorMessage || "Error getting rates",
          status: httpResponse.error?.status || httpResponse.status,
          errorMessage: httpResponse.error?.errorMessage || httpResponse.error?.message || "Error getting rates"
        }
      };
    }

    let error = {
      severity: severity,
      type: type,
      url: url,
      message: message,
      request: {
        url: url
      },
      response: sanitizedResponse,
      notes: {
        brand: brandInfo.brand,
        oid: _urlParams.oid || "",
        prid: _urlParams.prid || "",
        vehicle: _lead ? (_lead.vehicle || {}): "",
        customer: _lead ? (_lead.customer || {}): "",
      },
    };
    return this.httpClient.post<any>(environment.apiUrl + "/v1/api/error", error);

  }

  captureException(error: Error, type: string) {

    if(environment.production){

      LogRocket.captureException(error, {
          tags: {
            errorType: type,
          },
          extra: {
            brand: brandInfo.brand,
            // pageName
            // errorData
            // apiLink
          },
        });
    }
  }


  handleErrorWithD2CCapture(httpResponse, severity, service) {
    let errorMessage = "";
    let correlationId = sessionStorage.getItem("correlationId");

    console.log("handleErrorWithD2CCapture this: ", httpResponse);
    LoggingService.captureLogRocketError(httpResponse, "API", httpResponse.message || "Error Performing Request:", service);

    let message_short = "";

    if(httpResponse.error){

      if(httpResponse.error.message){
        message_short = httpResponse.error.message.substring(0, 60)+" - "+correlationId+"..." || "Error Performing Request";
      } else if(httpResponse.error.errorMessage){
        message_short = `${service}: ${httpResponse.error.errorMessage.substring(0, 60)} - correlationId: ${correlationId}` || "Error Performing Request";
      }
      else if(httpResponse.error.data){
        message_short = httpResponse.error.data.substring(0, 60)+" - "+correlationId+"..." || "Error Performing Request";
      }else{
        message_short = "Error Performing Request";
      }
    }

    this.captureD2CError(httpResponse, "API", message_short, severity, service).pipe(take(1)).subscribe(value =>     console.error("captureD2CError Calling D2C Error API...", value));

    if (httpResponse.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = httpResponse.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${httpResponse.status}\nMessage: ${httpResponse.message}`;
    }
    console.log("handleErrorWithD2CCapture: ", errorMessage);
    return throwError(errorMessage);
  }
  // Error handling
  handleError(httpResponse) {
    let errorMessage = "";
    console.log("this: ", httpResponse);
    LoggingService.captureLogRocketError(httpResponse, "API", httpResponse.message || "Error Performing Request:");

    if (httpResponse.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = httpResponse.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${httpResponse.status}\nMessage: ${httpResponse.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  captureMessage(message = "Error ", type) {
    if(environment.production){
      LogRocket.captureMessage(message, {
        tags: {
          errorType: type,
        },
        extra: {
          brand: brandInfo.brand,
          // pageName
          // errorData
          // apiLink
        },
      });
    }
  }
}
